import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../components/shared/base/base.component';

@Injectable({
  providedIn: 'root'
})
export class AgilityRiskUnsavedChangesGuardService implements CanDeactivate<BaseComponent> {
  constructor(private translateService: TranslateService) {
    this.translateService.getTranslation('en').subscribe((res: any) => {
      console.log(JSON.stringify(res));
    });
  }

  canDeactivate(component: BaseComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.isDirty) {
      const msg = this.translateService.instant('common.unsavedChanges');
      return confirm(msg);
    } else {
      return true;
    }
  }
}
